export default "__VITE_ASSET__Csk_tJf$__"